import { Info } from 'lucide-react'

/**
 * Single source of truth for the webhook-ownership explainer shown wherever
 * a tenant is about to attach a PBX flow to a Twilio number (and on the
 * Twilio integration setup form). The product rule (Phase 7): attach →
 * Versafy owns voice/fallback/status webhooks on the number; detach → all
 * three are cleared, no restore of any prior URL. Surfaced up-front so
 * detach-time isn't a surprise.
 *
 * Styled as a subtle aside (muted text + thin left border), not an Alert —
 * informational, present, but not visually heavy.
 */
export function WebhookOwnershipNotice({ className }: { className?: string }) {
  return (
    <div
      className={`flex items-start gap-2 border-l-2 border-muted-foreground/25 pl-3 py-1 text-xs text-muted-foreground ${className ?? ''}`}
    >
      <Info className="h-3.5 w-3.5 flex-shrink-0 mt-0.5" />
      <p>
        <span className="font-medium text-foreground/80">Webhook ownership.</span>{' '}
        <span>While a flow is attached, Versafy controls this number&apos;s voice,
        fallback, and status webhooks in Twilio. Detaching clears them —
        reconfigure your prior setup in the Twilio Console if needed.</span>
      </p>
    </div>
  )
}
